import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type Period from 'modules/attendance/store/models/Period'

import ErrorItem from './ErrorItem'

interface CompensationResult {
  employee_id: number
  error?: string
}

export interface CompensationReponse {
  successes: CompensationResult[]
  errors: CompensationResult[]
}

interface ErrorListProps {
  errors: CompensationResult[]
  selected: Period[]
}

const ErrorList = ({ errors, selected }: ErrorListProps) => {
  return (
    <Box
      maxHeight="s200"
      overflowY="scroll"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      width="full"
    >
      <Box justifyContent="flexStart" alignItems="flexStart" gapDivider>
        {errors.map((error) => (
          <ErrorItem key={error.employee_id} error={error} selected={selected} />
        ))}
      </Box>
    </Box>
  )
}

export default observer(ErrorList)
